import React, { Fragment } from 'react';
import Head from 'next/head';

import { appTitle } from '../../utils/constants';

type LayoutT = {
  children?: JSX.Element | JSX.Element[];
  title?: string;
};

function Layout({ children, title = appTitle }: LayoutT) {
  return (
    <Fragment>
      <Head>
        <title>{title}</title>
      </Head>

      {children}
    </Fragment>
  );
}

export default Layout;
